// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__rZd31","pages":"Layout_pages__10cLI"};